import React from 'react';
import './Services.css';
import { FaCarBattery, FaShippingFast, FaTools, FaGlobeAmericas, FaPowerOff } from 'react-icons/fa';

const Services = () => {
  return (
    <section className="services-section">
      <div className="container">
        <h2 className="section-title">Nossos Diferenciais</h2>
        <div className="services-grid">
          <div className="service-card">
            <FaCarBattery className="service-icon" />
            <h3>As Melhores Marcas</h3>
            <p>Trabalhamos com um portfólio completo das marcas mais confiáveis do mercado.</p>
          </div>
          <div className="service-card">
            <FaShippingFast className="service-icon" />
            <h3>Entrega Rápida</h3>
            <p>Levamos e instalamos a bateria onde você estiver em Belo Horizonte e região.</p>
          </div>
          <div className="service-card">
            <FaTools className="service-icon" />
            <h3>Instalação Especializada</h3>
            <p>Nossa instalação preserva 100% das configurações eletrônicas, sem riscos para o seu carro.



Seu carro já está desconfigurado? Recuperamos os parâmetros com nosso scanner profissional</p>
          </div>
          <div className="service-card">
            <FaGlobeAmericas className="service-icon" />
            <h3>Atendimento Nacional</h3>
            <p>Possuímos uma rede de prestadores de serviço qualificados em todo o Brasil para te atender.</p>
          </div>
          
          {/* NOVO CARD START-STOP ADICIONADO AQUI */}
          <div className="service-card">
            <FaPowerOff className="service-icon" />
            <h3>Especialistas em Start-Stop</h3>
            <p>Seu veículo com sistema Start-Stop exige tecnologia. Temos baterias EFB/AGM e equipe qualificada para garantir a performance do sistema.</p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Services;